document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.category-mega').forEach(function (menu) {
    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        menu.removeAttribute('open');
        var summary = menu.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.category-mega[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var selector = link.getAttribute('href');
      if (!selector || selector === '#') return;
      var target = document.querySelector(selector);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    });
  });

  function activateProductMedia(gallery, mediaId, playVideo) {
    if (!gallery || !mediaId) return;
    var activePanel = null;

    gallery.querySelectorAll('[data-product-media-item]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-product-media-item') === String(mediaId);
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);

      if (!isActive) {
        panel.querySelectorAll('video').forEach(function (video) {
          try { video.pause(); } catch (error) {}
        });
      } else {
        activePanel = panel;
      }
    });

    gallery.querySelectorAll('[data-product-thumbnail]').forEach(function (button) {
      var isActive = button.getAttribute('data-media-id') === String(mediaId);
      button.classList.toggle('is-active', isActive);
      if (isActive) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });

    if (activePanel && playVideo) {
      var video = activePanel.querySelector('video');
      if (video) {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      }
    }
  }

  document.querySelectorAll('[data-product-thumbnail]').forEach(function (button) {
    button.addEventListener('click', function () {
      var gallery = button.closest('[data-product-gallery]');
      activateProductMedia(gallery, button.getAttribute('data-media-id'), true);
    });
  });

  document.querySelectorAll('.product-form').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;
    var productInfo = form.closest('.product-info');
    var productMain = form.closest('.product-main');
    var gallery = productMain ? productMain.querySelector('[data-product-gallery]') : null;
    var price = productInfo ? productInfo.querySelector('[data-product-price]') : null;
    var availability = productInfo ? productInfo.querySelector('[data-product-availability]') : null;
    var sku = productInfo ? productInfo.querySelector('[data-product-sku]') : null;
    var button = form.querySelector('[data-add-to-cart]');

    function updateVariant() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var isAvailable = option.dataset.available === 'true';
      var isBackorder = option.dataset.backorder === 'true';

      if (price) {
        price.innerHTML = (option.dataset.compare ? '<s>' + option.dataset.compare + '</s>' : '') + '<strong>' + option.dataset.price + '</strong>';
      }
      if (availability) {
        if (isBackorder) availability.innerHTML = '<div class="availability availability--backorder">Backorder available</div>';
        else if (isAvailable) availability.innerHTML = '<div class="availability availability--in">In stock / available to order</div>';
        else availability.innerHTML = '<div class="availability availability--sold">Sold out</div>';
      }
      if (sku) {
        var nextSku = option.dataset.sku || '';
        sku.textContent = nextSku;
        var skuRow = sku.closest('[data-product-sku-row]');
        if (skuRow) skuRow.hidden = !nextSku;
      }
      if (button) {
        button.disabled = !isAvailable;
        button.textContent = isBackorder ? 'Place backorder' : (isAvailable ? 'Add to cart' : 'Sold out');
      }
      if (gallery && option.dataset.mediaId) activateProductMedia(gallery, option.dataset.mediaId, false);

      var productUrl = select.dataset.productUrl;
      if (productUrl && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', productUrl + '?variant=' + encodeURIComponent(option.value));
      }
    }

    select.addEventListener('change', updateVariant);
  });
});
